import { render, staticRenderFns } from "./SafeWithdrawal.vue?vue&type=template&id=6458d519&scoped=true&"
import script from "./SafeWithdrawal.vue?vue&type=script&lang=js&"
export * from "./SafeWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./SafeWithdrawal.vue?vue&type=style&index=0&id=6458d519&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458d519",
  null
  
)

export default component.exports